import { BasicInfoCta, BasicInfoMultipleCtas } from "@/types/dto/common/basic-info";
import basicInfoFactory from "./basic-info-factory";

export const ctaFactory = (cta: any): BasicInfoCta => ({
    callToActionText: cta?.title ?? cta?.callToActionText ?? "",
    callToActionUrl: cta?.url ?? cta?.callToActionUrl ?? "",
    hubspotFormInfo: cta?.hubSpotForm ?? cta?.hubspotFormInfo,
    brochureForm: cta?.brochureDisplay,
    ctaType: cta?.contentType ?? cta?.ctaType ?? "",
    promoCode: {
        promoCode: cta?.promoCode?.promoCode ?? "",
        promoCodeLabel: cta?.promoCode?.promoCodeLabel ?? ""
    },
    loginModalInfo: cta?.loginModalInfo ? basicInfoFactory(cta.loginModalInfo) : undefined,
    buttonVariant: cta?.buttonVariant ?? ""
});

const basicInfoMultipleCtasFactory = (data: any = {}): BasicInfoMultipleCtas => ({
    headerText: data?.headerText ?? "",
    copyText: data?.copyText ?? "",
    backgroundColor: data?.backgroundColor,
    ctas: Array.isArray(data?.ctas) ? data.ctas.map(ctaFactory) : []
});

export default basicInfoMultipleCtasFactory;